import React from 'react'
import { InfoList, InfoListWrapper } from './MyProfilePageStyled'
import { inject, observer } from 'mobx-react'
import { EmptyText } from '../../components/Common/CellText'

const Job = props => {
  const { authenticationStore } = props

  const { currentUser } = authenticationStore
  const nullText = <EmptyText>Chưa cập nhật</EmptyText>

  return (
    <InfoListWrapper>
      <InfoList>
        <dt>Phòng ban</dt>
        <dd>{currentUser?.department?.name || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Chức danh</dt>
        <dd>{currentUser?.position?.name || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Nghề nghiệp khi được tuyển dụng</dt>
        <dd>{currentUser?.other?.occupation || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Ngày tuyển dụng</dt>
        <dd>{currentUser?.other?.recruitment_day || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Ngạch công chức</dt>
        <dd>{currentUser?.other?.civil_servant_rank || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Mã ngạch</dt>
        <dd>{currentUser?.other?.quota_code || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Công việc chính được giao</dt>
        <dd>{currentUser?.other?.main_work || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Bậc lương</dt>
        <dd>{currentUser?.other?.salary_scale || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Hệ số</dt>
        <dd>{currentUser?.other?.coefficient || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Ngày hưởng</dt>
        <dd>{currentUser?.other?.received_date || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Phụ cấp chức vụ</dt>
        <dd>{currentUser?.other?.position_allowance || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Phụ cấp khác</dt>
        <dd>{currentUser?.other?.other_allowances || nullText}</dd>
      </InfoList>
    </InfoListWrapper>
  )
}

Job.propTypes = {}

export default inject('authenticationStore')(observer(Job))
